<template>
  <div class="part box" :class="{'filtered': part.filter}">
    <div class="progress" :style="{width:part.completeness*100+'%'}"></div>
    <img
      class="img"
      :src="!imgissue ? `//cdn.rebrickable.com/media/parts/elements/${part.element_id}.jpg` : part.part.part_img_url"
      @error="imgissue = true"
    />
    <div class="num">{{part.found}}/{{part.quantity}}</div>
    <div class="color" :class="{issue:imgissue}">{{part.color.name}}</div>
    <div class="txt">{{part.part.name}}</div>
    <ui-ripple-ink trigger=".box"></ui-ripple-ink>
  </div>
</template>



<script>
// //cdn.rebrickable.com/media/parts/elements/'+part.element_id+'.jpg'
export default {
  name: "part-box",
  data() {
    return {
      imgissue: this.part.element_id == null
    };
  },
  props: {
    part: Object
  },
  methods: {
    imgError() {
      this.$set(this.part, "imgissue", true);
    }
  },
  computed: {
    /*imgsrc() {
      if (false && this.part.element_id) {
        return (
          "//rebrickable.com/media/parts/elements/" +
          this.part.element_id +
          ".jpg"
        );
        //} else if(this.part.color.external_ids.LDraw){
        //      return '//rebrickable.com/media/parts/ldraw/'+this.part.color.id+'/'+this.part.part.part_num+'.png';
      } else {
        this.imageError = true;
        return this.part.part.part_img_url;
      }
    }*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.part.box {
  height: 150px;
  padding: 1.5em 0;
  text-align: center;
}

.part.filtered {
  opacity: 50%;
}

.part .target {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.part .img {
  position: relative;
  max-width: 100%;
  max-height: 100%;
}

.part .num {
  position: absolute;
  top: 5px;
  left: 5px;
  height: 1em;
}

.part .color {
  position: absolute;
  font-size: 0.7em;
  top: 5px;
  right: 5px;
  height: 1em;
}

.part .txt {
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  height: 1em;
}

.part .progress {
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.3;
  background: #2196f3;
  height: 100%;
}

.issue {
  font-weight: bold;
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/part-box.vue